import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-input-requirements-list',
    templateUrl: './input-requirements-list.component.html',
    standalone: false
})
export class InputRequirementsListComponent {
  constructor() {}

  @Input() text!: string;
  @Input() items!: string[];

}
